import axios from 'axios';
import { handleRequest, handleResponseException } from "./main.js";
import { hideLoading } from "./loading.js";
import { handleError } from "./error.js"

// 创建一个AXIOS实例
const service = axios.create(
  {
    baseURL:'/api',
    timeout: 180000,  // 请求超时（单位：毫秒）
    withCredentials: true
  });

// Request Interceptor
service.interceptors.request.use(
  config =>
  {
    handleRequest(config.headers);
    return config;
  },
  error =>
  {
    return Promise.reject(error);
  }
)

// Response Interceptor
service.interceptors.response.use(
  response =>
  {
    hideLoading()
    // 应答处理
    if (response.data.success === false){
    handleError(response,response.config.headers)
      return Promise.reject(response.data);
    }else{
      return response;
    }
      
  },
  error =>
  {
    console.log('error0000',error)
    hideLoading()
    // 应答异常处理
    if (error.response){
      handleResponseException(error.response.config.headers, error.response);
    }else{
       // 响应超时处理
      let response =
      {
        status: "响应超时",
        statusText: "请求已经发送，但接收应答响应超时",
      }
      handleResponseException(error.config.headers, response);
    }
    return Promise.reject(error)
  }
)

export default service
